export const locale = {
  lang: 'en',
  data: {
    ERROR_DIALOG: {
      HEADER: 'Cannot load page',
      MESSAGE: 'Please, try again.',
      BUTTON_TEXT: 'Ok',
    },
    GUIDELINE_DOCUMENT_DIALOG: {
      CLOSE: 'CLOSE'
    }
  },
};
